module.exports = __webpack_public_path__ + "img/az.d1c6ff3d.svg";